import { useTranslation } from "react-i18next";
import { UseFormReturn } from "react-hook-form";
import Text from "src/components/Displays/Text";
import CheckboxInput from "../Inputs/CheckboxInput";
import { Box, Link, Stack, Theme } from "@mui/material";
import { ContractSummaryFormValues } from "src/pages/ContractSummary/ContractSummary";
interface ContractSummaryFormProps {
  isSmartMeterSelected: boolean;
  isSmaSystemNotConnected?: boolean;
  isSmaSelfOnboaringSelected?: boolean;
  form: UseFormReturn<ContractSummaryFormValues, any, undefined>;
}

const ContractSummaryForm = ({
  form,
  isSmartMeterSelected,
  isSmaSystemNotConnected,
  isSmaSelfOnboaringSelected,
}: ContractSummaryFormProps) => {
  const { t } = useTranslation();

  return (
    <Stack gap={2}>
      {!isSmartMeterSelected && (
        <CheckboxInput
          control={form.control}
          label={
            <Box
              sx={(theme: Theme) => ({
                color: theme.palette.app.secondaryFont,
              })}
            >
              {t("page.contractSummary.smartMeterCheckboxText1")}
              <Link
                sx={(theme) => ({
                  color: theme.palette.app.secondaryFont,
                  textDecoration: "underline",
                })}
                href="https://www.lichtblick.de/veroeffentlichungen/"
                target="_blank"
              >
                {t("page.contractSummary.smartMeterCheckboxLink1")}
              </Link>
              {t("page.contractSummary.smartMeterCheckboxText2")}
              <Link
                sx={(theme) => ({
                  color: theme.palette.app.secondaryFont,
                  textDecoration: "underline",
                })}
                href="https://www.lichtblick.de/veroeffentlichungen/"
                target="_blank"
              >
                {t("page.contractSummary.smartMeterCheckboxLink2")}
              </Link>
              {t("page.contractSummary.and")}
              <Link
                sx={(theme: Theme) => ({
                  color: theme.palette.app.secondaryFont,
                  textDecoration: "underline",
                })}
                href="https://www.lichtblick.de/datenschutz/"
                target="_blank"
              >
                {t("page.contractSummary.walletLink2")}
              </Link>
              .
            </Box>
          }
          name="smartMeter"
        />
      )}

      <CheckboxInput
        control={form.control}
        label={
          <Box
            sx={(theme: Theme) => ({
              color: theme.palette.app.secondaryFont,
            })}
          >
            {t("page.contractSummary.smartMeterCheckboxText1")}
            <Link
              sx={(theme) => ({
                color: theme.palette.app.secondaryFont,
                textDecoration: "underline",
              })}
              href="https://www.lichtblick.de/veroeffentlichungen/"
              target="_blank"
            >
              {t("page.contractSummary.walletLink1")}
            </Link>
            {t("page.contractSummary.smartMeterCheckboxText2")}
            <Link
              sx={(theme) => ({
                color: theme.palette.app.secondaryFont,
                textDecoration: "underline",
              })}
              href="https://www.lichtblick.de/veroeffentlichungen/"
              target="_blank"
            >
              {t("page.contractSummary.smartMeterCheckboxLink2")}
            </Link>
            {t("page.contractSummary.and")}
            <Link
              sx={(theme) => ({
                color: theme.palette.app.secondaryFont,
                textDecoration: "underline",
              })}
              href="https://www.lichtblick.de/datenschutz/"
              target="_blank"
            >
              {t("page.contractSummary.walletLink2")}
            </Link>
            .
          </Box>
        }
        name="wallet"
      />

      {isSmaSystemNotConnected === true && (
        <Stack alignItems={"center"} mt={5}>
          <Stack
            sx={{
              gap: "10px",
              bgcolor: "#FFF",
              padding: "10px",
              borderRadius: "9px",
              border: "1px solid #696969",
              width: { xs: "100%", sm: "330px" },
            }}
          >
            <Text
              text={"Fast fertig!"}
              sx={{
                fontWeight: 700,
              }}
            />
            <Text
              text={
                "Sobald deine Anlage verbunden ist, kannst du den Vertrag abschließen."
              }
            />
            <Stack
              sx={{
                borderRadius: "5px",
                bgcolor: "#B6B6B6",
                padding: "8px 16px 8px 16px",
              }}
            >
              <Text
                text={"Verbindung zur Anlage ausstehend"}
                sx={{
                  fontWeight: 700,
                  color: "#F7F7F7",
                  textAlign: "center",
                }}
              />
            </Stack>
          </Stack>
        </Stack>
      )}

      {isSmaSelfOnboaringSelected === true && (
        <Stack alignItems={"center"} mt={5}>
          <Stack
            sx={{
              gap: "10px",
              bgcolor: "#FFF",
              padding: "10px",
              borderRadius: "9px",
              border: "1px solid #039C25",
              width: { xs: "100%", sm: "330px" },
            }}
          >
            <Text
              text={"Geschafft!"}
              sx={{
                fontWeight: 700,
              }}
            />
            <Text
              text={
                "Deine Anlage ist verbunden. Du kannst du den Vertrag abschließen."
              }
            />
            <Stack
              sx={{
                borderRadius: "5px",
                bgcolor: "#C6FFB2",
                padding: "8px 16px 8px 16px",
              }}
            >
              <Text
                text={"Anlage erfolgreich verbunden"}
                sx={{
                  fontWeight: 700,
                  color: "#367056",
                  textAlign: "center",
                }}
              />
            </Stack>
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};

export default ContractSummaryForm;
